import React from 'react';
import { Form } from 'react-final-form';
import { useAppSelector } from '../../../../store/hooks';
import { Button, Popover } from '../../../UI';
import { IconLogo, IconGear, IconBars } from '../../../Icon';
import UserSettingsContent from '../UserSettingsContent';
import AdminChatForm from './admin/AdminChatForm';
import { FormValues } from '../../../../store/chat/types';
import { selectIsAdmin } from '../../../../store/user/slice';
import styles from './TopBar.module.scss';
import NavLinks from '../NavLinks/NavLinks';

interface TopBarProps {
  onMobileMenuToggle: () => void;
  isChatPage: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ onMobileMenuToggle, isChatPage }) => {
  const { isAdminOpen, formValues } = useAppSelector((state) => state.chat);
  const { isMobile } = useAppSelector((state) => state.app);
  const isAdmin = useAppSelector(selectIsAdmin);

  return (
    <>
      <div className={styles.topBar}>
        <div className={styles.leftContent}>
          <div className={styles.logoContainer}>
            <IconLogo height={36} />
          </div>
          {!isMobile && <NavLinks direction="row" />}
        </div>
        <div className={styles.settingsContainer}>
          {isMobile ? (
            <Button
              variant="ghost"
              icon={<IconBars size={24} />}
              aria-label="Menu"
              onClick={onMobileMenuToggle}
            />
          ) : (
            <Popover
              trigger={
                <Button variant="ghost" icon={<IconGear size={24} />} aria-label="Settings" />
              }
            >
              {(closePopover) => <UserSettingsContent onClose={closePopover} />}
            </Popover>
          )}
        </div>
      </div>

      {isAdmin && isChatPage && isAdminOpen && (
        <div className={styles.adminFormContainer}>
          <Form<FormValues>
            initialValues={formValues}
            onSubmit={() => {}}
            subscription={{ values: true }}
            render={({ values }) => <AdminChatForm values={values || {}} />}
          />
        </div>
      )}
    </>
  );
};

export default TopBar;
